import { render, staticRenderFns } from "./managementTask.vue?vue&type=template&id=7f1c561e&"
import script from "./managementTask.vue?vue&type=script&lang=js&"
export * from "./managementTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports